import React, { useState } from 'react';
import { FaUser } from "react-icons/fa";
import { IoLockClosed } from "react-icons/io5";
import MinervaLogo from '../images/MinervaLogo';
import { PiEyeLight, PiEyeSlashLight } from "react-icons/pi";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/authService';
import { setUser } from '../reduxSlices/auth/authSlice';
import { browserLocalPersistence, browserSessionPersistence, setPersistence } from 'firebase/auth';
import { auth } from '../config/firebase';




function Login() {
    const [isUsernameFocused, setIsUsernameFocused] = useState(false);
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
    const [isShaking, setIsShaking] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogin = async () => {
        setLoading(true); 
        setError(false);
        setIsShaking(false);
      
        try {

            const userData = await login(email, password, dispatch, setUser, rememberMe);
      
          // ✅ Safety check
          if (!userData?.role) throw new Error("User has no role");
      
          // 🚀 Redirect based on role
          switch (userData.role) {
            case "super_admin":
            case "admin":
            default:
              navigate("/");
          }
        } catch (error) {
          console.error("Login error:", error.message);
          setError(true);
          setIsShaking(true);
          setTimeout(() => setIsShaking(false), 200);
        } finally {
          setLoading(false);
        }
      };



  return (
    <div className='flex bg-white h-screen w-screen overflow-hidden'>
        <div className='flex flex-1 bg-stone-800 items-center justify-center'>
            <MinervaLogo className='h-44'/>
            <img src={require('../images/back.png')} className='absolute left-0 bottom-0 h-3/6 opacity-80' />
        </div>
        <div className='relative flex flex-1 flex-col mx-auto my-auto p-10  items-center justify-center h-screen'>
            <div className='flex flex-col pb-4 mt-5'>
                <div className='flex flex-row items-center'>
                    <img src={require('../images/logo-small.png')} className='w-12'/>
                    <span className='text-5xl font-thin text-stone-600 ml-2'>Login</span>
                </div>

                <div className='relative mt-6'>
                    <FaUser fontSize={23} className={`${isUsernameFocused ? 'text-customeOrange' : 'text-stone-400'} absolute top-1/2 -translate-y-1/3 left-3`} />
                    <input 
                        type='text' 
                        placeholder='Username' 
                        onChange={(e) => {setEmail(e.target.value); setError(false)}}
                        onFocus={() => setIsUsernameFocused(true)} 
                        onBlur={() => setIsUsernameFocused(false)} 
                        className={`${isUsernameFocused ? 'placeholder-customeOrange' : 'placeholder-stone-300'} text-stone-600 mt-2 rounded-lg text-sm  active:outline-none h-14 w-[30rem] border border-stone-300 px-4 pl-12 shadow-sm bg-stone-50 focus:outline-customeOrange placeholder:font-light`} 
                    />
                </div>

                <div className='relative mt-6 focus-within:text-customeOrange'>
                    <IoLockClosed fontSize={23} className={`${isPasswordFocused ? 'text-customeOrange' : 'text-stone-400'} absolute top-1/2 -translate-y-1/3 left-3`} />
                    <input 
                        type={showPassword ? 'text' : 'password'}
                        placeholder='Password' 
                        onChange={(e) => {setPassword(e.target.value); setError(false)}}
                        onFocus={() => setIsPasswordFocused(true)} 
                        onBlur={() => setIsPasswordFocused(false)} 
                        className={`${isPasswordFocused ? 'placeholder-customeOrange' : 'placeholder-stone-300'} text-stone-600 mt-2 rounded-lg text-sm active:outline-none h-14 w-[30rem] border border-stone-300 px-4 pl-12 shadow-sm bg-stone-50 focus:outline-customeOrange placeholder:font-light`}
                    />
                    {showPassword ? (
                        <PiEyeSlashLight
                        onClick={() => setShowPassword(false)}
                        fontSize={23}
                        className='text-stone-400 absolute top-1/2 -translate-y-1/3 right-3 hover:cursor-pointer'
                        />
                    ) : (
                        <PiEyeLight
                        onClick={() => setShowPassword(true)}
                        fontSize={23}
                        className='text-stone-400 absolute top-1/2 -translate-y-1/3 right-3 hover:cursor-pointer'
                        />
                    )}
                </div>
                {error && <span className='text-red-700 text-sm mt-2'>Invalid username or password</span>}
                <div className='flex justify-between mt-4'>
                    <div className='flex justify-center items-center'>
                        <input type='checkbox' className='h-5 w-5 text-customeOrange focus:ring-customeOrange border-stone-300 rounded' checked={rememberMe} onChange={() => setRememberMe(!rememberMe)}/>   
                        <span className='text-sm text-stone-400 ml-1 font-light'>Keep me logged in</span>
                    </div>
                    <span className='text-customeOrange text-sm'>Password Recovery</span>
                </div>
                <button disabled={loading} onClick={handleLogin} className={`flex items-center justify-center gap-3 mt-14 bg-stone-800 text-white p-3 rounded-lg font-medium hover:bg-customeOrange active:bg-stone-700 h-14 ${isShaking ? 'animate-shake' : ''}`}>
                {loading && (
                    <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                )}
                Login
                </button>
            </div>
            <span className='absolute bottom-4 text-center text-sm w-full text-stone-300 font-light'>&copy; Minerva Analytics Inc 2024 - V1.0.0</span>
        </div>
    </div>
  )
}

export default Login